import gql from "graphql-tag";

export const fragment_GetCountsResponse = gql`
  fragment GetCountsResponse on GetCountsResponse {
    counts {
      count
    }
  }
`;
